import { CHANGE_MIGROS_LOGIN_STATUS, CLEAR_REDIRECT, SAVE_REDIRECT } from './login.actionTypes';

export const actionCreators = {
	doChangeMigrosLoginStatus: (migrosLoginStatus: string) => ({
		type: CHANGE_MIGROS_LOGIN_STATUS,
		migrosLoginStatus,
	}),
	doSaveRedirectRoutePath: (routePath: Object) => ({
		type: SAVE_REDIRECT,
		routePath,
	}),
	doClearRedirectRoutePath: () => ({
		type: CLEAR_REDIRECT,
	}),
};

export type LoginActionType =
	| ReturnType<typeof actionCreators.doChangeMigrosLoginStatus>
	| ReturnType<typeof actionCreators.doSaveRedirectRoutePath>
	| ReturnType<typeof actionCreators.doClearRedirectRoutePath>;
